import { Button, Modal, Text } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

interface EditSuccessModalProps {
  opened: boolean;
  onClose: () => void;
}

export const EditSuccessModal = ({ opened, onClose }: EditSuccessModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal.Root opened={opened} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{t('비밀번호 변경 완료')}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Text fz={16} fw={400} c="gray.7">
            {t('비밀번호 변경이 완료되었습니다.')}

            <br />
            {t('다시 로그인해 주세요.')}
          </Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="filled" color="infgreen" size="md" radius="md" onClick={onClose}>
            {t('확인')}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
